/**
 * AI Settings - 繁體中文本地化
 */

export default {
    aiSettings: {
        title: 'AI 設定',
        description: '設定 AI 如何回應您的請求',
        loading: '載入設定中...',
        saving: '儲存中...',
        saveSuccess: '設定儲存成功',
        saveError: '儲存設定失敗，請重試',
        selectLanguage: '選擇 AI 輸出語言',

        outputLanguage: {
            title: 'AI 輸出語言',
            description: '選擇 AI 在回答問題和產生內容時使用的語言',
        },

        error: {
            title: '錯誤',
        },

        info: {
            title: '運作原理：',
            point1: 'AI 將使用您選擇的語言回覆所有對話',
            point2: '設定會在您的所有裝置間同步',
            point3: '變更會立即對新對話生效',
        },
    },
};
